import React, { useEffect, useState } from 'react';
import ProfileAvatar from "../../components/assets/profile.jpg";
import authStorage from '../../utilities/Storage';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

const AddServiceAuth = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState(null);
    const [company_name, setCompany_Name] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');
    const [services, setServices] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    
    const [formData, setFormData] = useState({
        service_name: "",
        description: ""
    });

    function getUserRegistrationDetails() {
        const userData = authStorage.getUser();
        if (!userData) return;
        
        try {
            const user = JSON.parse(userData);
            setEmail(user.email);
            setCompany_Name(user.company_name);
            loadServices(user.email, user.company_name);
        } catch (error) {
            console.error("Failed to parse user data:", error);
        }
    }

    const loadServices = async (userEmail, userCompany) => {
        try {
            console.log('Loading services for:', userEmail, userCompany);
            const response = await axios.get('https://backend-livestream-production.up.railway.app/api/get-services', {
                params: {
                    email: userEmail,
                    company_name: userCompany
                }
            });
            console.log('Services loaded:', response.data);
            setServices(response.data.data || []);
        } catch (error) {
            console.error('Error loading services:', error);
            setErrors({ load: 'Failed to load services. Please try again.' });
            setServices([]);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.service_name.trim()) newErrors.service_name = 'Service name is required';
        if (!formData.description.trim()) newErrors.description = 'Service description is required';
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const getUsersEmail = () => {
        const userData = authStorage.getUser();
        if (!userData) return;
        
        try {
            const user = JSON.parse(userData);
            setEmail(user.email);
            setCompany_Name(user.company_name);
        } catch (error) {
            console.error("Failed to parse user data:", error);
        }
    };

    const handleContinueButton = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const response = await axios.patch('https://backend-livestream-production.up.railway.app/api/update-user', {
                email: email,
                company_name: company_name
            }, {
                params: {
                    email: email,
                    company_name: company_name
                }
            });

            if (response.data.ok === 1) {
                setSuccessMessage('Profile completed successfully! Redirecting...');
                setTimeout(() => {
                    navigate('/'); // Change this to your desired redirect path
                }, 2000);
            } else {
                throw new Error(response.data.error || 'Failed to update user status');
            }
        } catch (error) {
            console.error('Continue error:', error);
            setErrors({ 
                submit: error.response?.data?.message || 
                       error.response?.data?.error || 
                       error.message ||
                       'Failed to complete profile. Please try again.' 
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }
        
        setIsSubmitting(true);
        try {
            const userData = authStorage.getUser();
            if (!userData) throw new Error('User not authenticated');
            
            const user = JSON.parse(userData);
            
            const response = await axios.post('https://backend-livestream-production.up.railway.app/api/add-service', {
                service_name: formData.service_name,
                service_description: formData.description,
                email: user.email,
                campany_name: user.company_name
            });

            console.log('Add Service Response:', response.data);
            
            await loadServices(user.email, user.company_name);
            setSuccessMessage('Service added successfully!');
            setFormData({
                service_name: "",
                description: ""
            });
            setTimeout(() => setSuccessMessage(''), 3000);
            
        } catch (error) {
            console.error('Submission error:', error);
            setErrors({ 
                submit: error.response?.data?.message || 
                       error.response?.data?.error || 
                       error.message ||
                       'Failed to add service. Please try again.' 
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const filteredServices = Array.isArray(services) 
        ? services.filter(service => {
            if (!service) return false;
            return (
                (service.service_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
                (service.service_description?.toLowerCase() || '').includes(searchTerm.toLowerCase())
            );
        })
        : [];

    useEffect(() => {
        getUserRegistrationDetails();
        getUsersEmail();
    }, []);

    const steps = [
        { id: 1, name: 'Personal Details', path: '#', current: location.pathname === '/add-personal-detail' },
        { id: 2, name: 'Add Products', path: '#', current: location.pathname === '/add-product' },
        { id: 3, name: 'Add Services', path: '#', current: location.pathname === '/add-service' },
    ];

    return (
        <div className="container-fluid vh-100 bg-light p-0 overflow-hidden">
            {/* Mobile Header */}
            <div className="d-md-none bg-dark text-white p-3 d-flex justify-content-between align-items-center">
                <button 
                    className="btn btn-outline-light"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                    <i className={`bi bi-${mobileMenuOpen ? 'x' : 'list'}`}></i>
                </button>
                <h5 className="mb-0">{company_name || 'Your Company'}</h5>
                <img 
                    src={ProfileAvatar} 
                    alt="Profile" 
                    className="rounded-circle"
                    style={{ 
                        width: '40px', 
                        height: '40px', 
                        objectFit: 'cover',
                        border: '2px solid #3498db'
                    }}
                />
            </div>

            <div className='row h-100 g-0'>
                {/* Sidebar */}
                <div 
                    className={`col-md-3 col-lg-2 sidebar ${mobileMenuOpen ? 'd-block' : 'd-none d-md-block'}`}
                    style={{ 
                        backgroundColor: '#2c3e50',
                        overflowY: 'auto',
                        zIndex: 1000,
                        height: 'calc(100vh - 56px)'
                    }}
                >
                    <div className="position-sticky pt-4">
                        <div className="text-center mb-4 d-none d-md-block">
                            <img 
                                src={ProfileAvatar} 
                                alt="Profile" 
                                className="rounded-circle shadow mb-3"
                                style={{ 
                                    width: '90px', 
                                    height: '90px', 
                                    objectFit: 'cover',
                                    border: '3px solid #3498db'
                                }}
                            />
                            <h6 className="fw-bold text-white">{company_name || 'Your Company'}</h6>
                            {email && <small className="text-muted">{email}</small>}
                        </div>
                        
                        <nav className="nav flex-column px-3">
                            {steps.map((step) => (
                                <div key={step.id} className="mb-2">
                                    <div 
                                        className={`nav-link d-flex align-items-center ${step.current ? 'active-step' : 'text-white'}`}
                                        style={{ 
                                            cursor: 'pointer',
                                            borderRadius: '8px',
                                            padding: '12px 16px',
                                            fontWeight: '600',
                                            transition: 'all 0.3s ease',
                                            backgroundColor: step.current ? '#3498db' : 'transparent',
                                            marginBottom: '4px'
                                        }}
                                        onClick={() => {
                                            navigate(step.path);
                                            setMobileMenuOpen(false);
                                        }}
                                    >
                                        <span 
                                            className={`badge me-3 ${step.current ? 'bg-white text-primary' : 'bg-secondary text-white'}`}
                                            style={{ 
                                                width: '28px', 
                                                height: '28px', 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                justifyContent: 'center',
                                                fontSize: '0.9rem',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            {step.id}
                                        </span>
                                        <span style={{ fontSize: '0.95rem' }}>{step.name}</span>
                                    </div>
                                    {step.id < steps.length && (
                                        <div className="ms-5" style={{ 
                                            height: '24px', 
                                            borderLeft: '2px solid rgba(255,255,255,0.2)',
                                            marginLeft: '13px'
                                        }}></div>
                                    )}
                                </div>
                            ))}
                        </nav>
                    </div>
                </div>

                {/* Main Content Area */}
                <div className='col-md-9 col-lg-10 d-flex flex-column' style={{ height: 'calc(100vh - 56px)' }}>
                    <div className="row g-0 flex-grow-1">
                        {/* Form Column */}
                        <div className='col-lg-6 col-xl-5 d-flex justify-content-center align-items-center p-3'>
                            <div className="card border-0 shadow-sm p-3 p-md-4 w-100" style={{ maxWidth: "500px" }}>
                                <div className="text-center mb-4">
                                    <h2 className="fw-bold text-primary">Add Service Details</h2>
                                    <p className="text-muted">Fill in the details to add a service to your Profile</p>
                                </div>
                                
                                {successMessage && (
                                    <div className="alert alert-success mb-4">
                                        <i className="bi bi-check-circle-fill me-2"></i>
                                        {successMessage}
                                    </div>
                                )}
                                
                                {errors.submit && (
                                    <div className="alert alert-danger mb-4">
                                        <i className="bi bi-exclamation-triangle-fill me-2"></i>
                                        {errors.submit}
                                    </div>
                                )}
                                
                                {errors.load && (
                                    <div className="alert alert-warning mb-4">
                                        <i className="bi bi-exclamation-circle-fill me-2"></i>
                                        {errors.load}
                                    </div>
                                )}
                                
                                <form className="needs-validation" noValidate onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="serviceName" className="form-label fw-semibold">
                                            Service Name <span className="text-danger">*</span>
                                        </label>
                                        <input 
                                            type="text" 
                                            className={`form-control py-2 ${errors.service_name ? 'is-invalid' : ''}`}
                                            id="serviceName" 
                                            placeholder="Enter service name"
                                            name="service_name"
                                            value={formData.service_name}
                                            onChange={handleChange}
                                            required 
                                        />
                                        {errors.service_name && (
                                            <div className="invalid-feedback">{errors.service_name}</div>
                                        )}
                                    </div>
                                    
                                    <div className="mb-4">
                                        <label htmlFor="description" className="form-label fw-semibold">
                                            Service Description <span className="text-danger">*</span>
                                        </label>
                                        <textarea 
                                            className={`form-control py-2 ${errors.description ? 'is-invalid' : ''}`}
                                            id="description" 
                                            rows="3" 
                                            placeholder="Describe your service..."
                                            name="description"
                                            value={formData.description}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                        {errors.description && (
                                            <div className="invalid-feedback">{errors.description}</div>
                                        )}
                                    </div>
                                    
                                    <div className="d-grid gap-2">
                                        <button 
                                            type="submit" 
                                            className="btn btn-primary py-2 fw-semibold"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Adding Service...
                                                </>
                                            ) : (
                                                'Add Service'
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        
                        {/* Preview Column - Hidden on small screens */}
                        <div className='col-lg-6 col-xl-7 bg-white d-none d-lg-flex flex-column border-start'>
                            <div className="d-flex flex-column h-100">
                                {/* Stats Header */}
                                <div className="p-4 border-bottom">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h3 className="fw-bold mb-0">Finish setup</h3>
                                        <div className="btn-group">
                                            <button className="btn btn-sm btn-outline-secondary">
                                                <i className="bi bi-filter"></i>
                                            </button>
                                            <button className="btn btn-sm btn-outline-secondary">
                                                <i className="bi bi-sort-down"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Recent Services with Search */}
                                <div className="p-4 pt-0 flex-grow-1 d-flex flex-column">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h4 className="fw-bold mb-0">Recent Services</h4>
                                        <div className="input-group" style={{ maxWidth: '300px' }}>
                                            <input 
                                                type="text" 
                                                className="form-control form-control-sm" 
                                                placeholder="Search services..." 
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                            <button className="btn btn-sm btn-outline-secondary" type="button">
                                                <i className="bi bi-search"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="list-group flex-grow-1 overflow-auto">
                                        {filteredServices.length > 0 ? (
                                            filteredServices.map((service, index) => (
                                                <div key={index} className="list-group-item list-group-item-action">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <h6 className="fw-semibold mb-1">{service.service_name}</h6>
                                                            <div className="d-flex flex-wrap">
                                                                <small className="text-muted me-2">{service.service_description}</small>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex align-items-center">
                                                            <button className="btn btn-sm btn-outline-danger">
                                                                <i className="bi bi-trash"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="text-center py-4 text-muted">
                                                <i className="bi bi-info-circle-fill me-2"></i>
                                                {services.length === 0 ? 'No services added yet' : 'No matching services found'}
                                            </div>
                                        )}
                                    </div>

                                    {/* Continue Button */}
                                    {services.length >= 2 && (
                                        <div className="mt-3 pt-2 border-top text-end">
                                            <button 
                                                type="button" 
                                                className="btn btn-success"
                                                onClick={handleContinueButton}
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Processing...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="bi bi-list-ul me-2"></i> Continue to Dashboard
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddServiceAuth;